import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { PatientDashboardComponent } from '../patients/dashboard-page/dashboard-page.component';
import { AdminGuard } from '../calvin-emr-shared/guards/admin.guard';
import { AuthGuard } from '../calvin-emr-shared/guards/auth.guard';
import { AssignPatientsPageComponent } from './assign-patients-page/assign-patients-page.component';
import { StudentListPageComponent } from './student-list-page/student-list-page.component';
import { StudentsPageComponent } from './students-page/students-page';
import {
  PATH_ASSIGN_PATIENTS,
  PATH_ID_PARAM,
  PATH_STUDENTS,
  PATH_STUDENTS_LIST,
  PATH_VIEW_STUDENT_PATIENT,
} from './students.global';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';
import { PATH_LOGIN } from 'src/app/login/login.global';

export const studentsRoutes: Routes = [
  {
    path: PATH_STUDENTS,
    component: StudentsPageComponent,
    canActivate: [
      () => inject(AuthGuard).canActivate(PATH_LOGIN),
      () => inject(AdminGuard).canActivate(PATH_PATIENTS),
    ],
    canActivateChild: [
      () => inject(AuthGuard).canActivateChild(PATH_LOGIN),
      () => inject(AdminGuard).canActivateChild(PATH_PATIENTS),
    ],
    children: [
      { path: '', redirectTo: PATH_STUDENTS_LIST, pathMatch: 'full' },
      { path: PATH_STUDENTS_LIST, component: StudentListPageComponent },
      { path: PATH_ASSIGN_PATIENTS, component: AssignPatientsPageComponent },
      {
        path: `${PATH_VIEW_STUDENT_PATIENT}/:${PATH_ID_PARAM}`,
        component: PatientDashboardComponent,
      },
    ],
  },
];
